import leftsidebarpopulate from '/src/lib/custom/js/leftsidebarpopulate.js';
const mainPageEvents = {

    mainPageEventsInit() {
        unloadInit();

        const WIDTH_BREAKPOINT = 1220;
        const CLOSE_SIDEBAR_THRESHOLD = 1220;

        /**
         *
         * THE LOGIC WORKS FOR THE SIDEBAR TO SHOW ON DIFFERNT SCREEN. it's just when you open the
         * window in <1220 and resize to greater then 1220 where the session storage value is null, it does not
         * show the side bar as default which is fine and resize is only for development
         * Where as if you go from Bigger > 1220 to smaller it does hide but then require double click to open the
         * nav when the width is less then 1220 - These are all development issues - production is fine so don't change
         * any logic here
         */

        // Helper function to safely get the sidebar status from session storage
        function getSidebarStatus() {
             var showHomebar = true;
             var navbar = document.querySelector(".navbar");
             navbar.classList.add("homebar");

            if (isNotResumeBuilderPath()) {
                // Perform your action here
                try {
                    if (!sessionStorage) return false;
                    var status = null;
                    status = sessionStorage.getItem('sidebarOpenDesktopHome');
                    if (status === 'true') {
                        navbar.classList.remove("homebar");
                        showHomebar = false;
                        var footersd = document.getElementById("footersd");
                        if (footersd) footersd.style.maxWidth = "1300px";
                        var customLocale3 = document.getElementById("custom-locale3");
                        if (customLocale3) customLocale3.style.display = 'none';
                        var pricingbtnDiv = document.getElementById("pricingbtnDiv");
                        if (pricingbtnDiv) pricingbtnDiv.style.display = 'none';

                    }
                    return status === 'true' ? true : status === 'false' ? false : false;
                } catch (e) {
                    console.error('Error retrieving sidebar status from session storage:', e);
                    return false;
                }
            }



            try {
                if (!sessionStorage) return null;
                var status = null;
                status = sessionStorage.getItem('sidebarOpenDesktop');
                return status === 'true' ? true : status === 'false' ? false : null;
            } catch (e) {
                console.error('Error retrieving sidebar status from session storage:', e);
                return null;
            }
        }

        function isNotResumeBuilderPath() {
            const excludedPaths = [
              '/generate-resume-from-job-posting',
              '/generate-resume-from-text',
              '/generate-coverletter',
              '/faqs',
              '/pricing',
              '/resume-ats-checker',
              '/contactus',
              '/privacypolicy',
              '/terms-and-conditions',

            ];
            return !excludedPaths.includes(stripLocaleFromPath(window.location.pathname));
          }

        function processAndHideBackdrop() {
            if (
                ($('#resumeSidebar').length && $('#resumeSidebar').hasClass('open')) || // Check if resumeSidebar exists and is open
                ($('#fileUploadModal').length && $('#fileUploadModal').hasClass('fileUpload-show')) ||
                ($('#page-setup-myModal').length && $('#page-setup-myModal').css('display') !== 'none' && $('#page-setup-myModal').css('display') !== '') // Check if pageSetupModal is visible
            ) {//don't hide sidebar
            } else {
                hideModalBackDrop();
            }
        }

        // Helper function to safely set the sidebar status in session storage
        function setSidebarStatus(isOpen) {
            try {
                if (window.innerWidth > CLOSE_SIDEBAR_THRESHOLD) {
                    if (isNotResumeBuilderPath()) {
                        sessionStorage.setItem('sidebarOpenDesktopHome', isOpen.toString());
                    } else {
                        sessionStorage.setItem('sidebarOpenDesktop', isOpen.toString());
                    }
                }

            } catch (e) {
                console.error('Error saving sidebar status to session storage:', e);
            }
        }

        var sidebarOpenDesktop = getSidebarStatus();
        var sidebarOpenMobile = false; // Default to closed on mobile
        var rightDrawerOpen = false; // Default to closed right drawer

        function initializeSidebar() {
            // Determine if the sidebar should be open or closed on desktop based on the width
            // Hide elements initially
            var editbtn = document.querySelector(".editbtn");
            var brand = document.querySelector(".brand");
            var dropdown = document.getElementById("dropdown-menu");
            var openbtn = document.getElementById("openbtn");
            var recentResume = document.getElementById("recent-resume");
            //console.log ('initializeSidebar Populating leftsidebar');
            leftsidebarpopulate.init();
            applyLeftNavButtonActiveClass();




            if (sidebarOpenDesktop === null) {
                // Default behavior when status is not set in session storage
                sidebarOpenDesktop = window.innerWidth > CLOSE_SIDEBAR_THRESHOLD;
            }
            adjustContentContainer(); // Adjust the layout based on the initial state
            // Show the elements once the layout is set
            editbtn.style.visibility = "visible";
            brand.style.visibility = "visible";
            dropdown.style.visibility = "visible";
            openbtn.style.visibility = "visible";
            recentResume.style.visibility = 'hidden';
            const resumeUrl = getRecentResumeUrl();
            if (resumeUrl) {
                const fileName = resumeUrl.substring(resumeUrl.lastIndexOf('/') + 1);
                const resumeName = fileName.replace('.html', '');
                recentResume.style.visibility = "visible";
                recentResume.innerHTML = `
                <svg width="22" height="22" fill="currentColor" class="" style="vertical-align: middle; margin-right: 5px;">
                    <use href="#icon-file"></use>
                </svg><span class="current-resume-name">
                ${getI18n('recent')}: ${resumeName}</span>
                `;
                recentResume.style.visibility = "visible";
            }

        }

        $(document).on('click', '#brand', function (t) {
            t.stopImmediatePropagation();
            toggleDropdown();
        });

        $(document).on('click', '#openbtn', function (t) {
            t.stopImmediatePropagation();
            toggleNav();
            scrollToTopWhenWindowScrolls();
        });

        $(document).on('click', '#loggedin-right-main:has(*)', function (t) {
            t.stopImmediatePropagation();
            toggleRightDrawer();
            scrollToTopWhenWindowScrolls();
        });

        $(document).on('click', '#rightdrawercloseButton', function (t) {
            t.stopImmediatePropagation();
            toggleRightDrawer();
            scrollToTopWhenWindowScrolls();
        });

        $(document).on('click', '#closeSidebar', function (t) {
            t.stopImmediatePropagation();
            closeSideBar();
        });

        $('#rightdrawer-main-logout').click(function (t) {
            t.stopPropagation();
            closeRightDrawer();
            logout();
            scrollToTopWhenWindowScrolls();

        });

        // Copy text to clipboard
        $('#copyTextBtn').on('click', function () {
            $('#fullTextContent').select();
            document.execCommand('copy');
        });

        $(document).on('click', function (event) {
            var $dropdown = $("#dropdown-menu");
            var $brand = $('#brand');
            var $recentResume = $('#recent-resume');

            var $sidebar = $("#mySidebar");
            var $rightDrawer = $("#myRightDrawer");
            var $fileUploadModal = $("#fileUploadModal");
            var $rightDrawerButton = $("#rightdrawercloseButton");
            var editbtn = document.querySelector(".editbtn");
            var dropdown = document.getElementById("dropdown-menu");
            var signupButton = document.getElementById("signup-right");
            var loginButton = document.getElementById("login-right");

            if ($brand.length && !$brand.has(event.target).length && !$dropdown.has(event.target).length) {
                $dropdown.hide();
            }

            if ($sidebar.length && window.innerWidth <= WIDTH_BREAKPOINT && $sidebar.css('width') === $(':root').css('--mobile-sidebar-width') && !$sidebar.has(event.target).length && !$(event.target).closest('.openbtn').length) {
                $sidebar.css('width', '0');
                editbtn.style.left = "50px";
                brand.style.left = "55px";
                recentResume.style.left = (parseInt(brand.style.left, 10) + 50) + 'px';
                dropdown.style.left = (parseInt(brand.style.left, 10) + (brand.offsetWidth > 200 ? 100 : brand.offsetWidth) / 2) + 'px';
                $brand.css('visibility', 'visible');
                $recentResume.css('visibility', 'visible');
                sidebarOpenMobile = false;
                if (signupButton) signupButton.disabled = false;
                if (loginButton) loginButton.disabled = false;
                console.log('MainPage Event hidding modal backdrop 1');
                processAndHideBackdrop();
                $(".openbtn").attr("data-original-title", getI18n('home.openSidebar'));
                $('[data-toggle="tooltip"]').tooltip('hide'); // Hide tooltip after clicking outside
            }

            if ($rightDrawerButton.length && !$rightDrawer.has(event.target).length && !$rightDrawerButton.has(event.target).length && !$sidebar.has(event.target).length) {
                if (
                    ($('#resumeSidebar').length && $('#resumeSidebar').hasClass('open')) || // Check if resumeSidebar exists and is open
                    ($('#fileUploadModal').length && $('#fileUploadModal').hasClass('fileUpload-show')) ||
                    ($('#page-setup-myModal').length && $('#page-setup-myModal').css('display') !== 'none' && $('#page-setup-myModal').css('display') !== '') // Check if pageSetupModal is visible
                ) {
                    //do nothing
                } else {
                    if (signupButton) signupButton.disabled = false;
                    if (loginButton) loginButton.disabled = false;
                    console.log('MainPage Event hidding modal backdrop 2');
                    processAndHideBackdrop();
                }
                $rightDrawer.css('width', '0');
                rightDrawerOpen = false;
            }
        });

        $(document).on('click', '#settingslink, #settingsbtn', function (t) {
            t.stopImmediatePropagation();
            const $metaThemeColor = $('meta[name="theme-color"]');
            $('html').toggleClass('dark-theme');
            let isDarkMode = $('html').hasClass('dark-theme');
            $metaThemeColor.attr("content", isDarkMode ? "#323639" : "#f2f2f2");
            localStorage.setItem('dark-mode', isDarkMode);
            let tooltiptext = isDarkMode ? getI18n('home.setLightkMode') : getI18n('home.setDarkMode');
            $("#settingsbtn").attr("data-original-title", tooltiptext).tooltip('dispose').tooltip();
        });

        function toggleRightDrawer() {
            var rightDrawer = document.getElementById("myRightDrawer");

            rightDrawerOpen = !rightDrawerOpen;
            if (rightDrawerOpen) {
                showModalBackDrop(true);
                rightDrawer.style.width = getComputedStyle(document.documentElement).getPropertyValue(window.innerWidth > WIDTH_BREAKPOINT ? '--desktop-rightdrawer-width' : '--mobile-rightdrawer-width');
            } else {
                console.log('MainPage Event hidding modal backdrop 3');
                processAndHideBackdrop();
                rightDrawer.style.width = "0";
            }
        }

        function closeRightDrawer() {
            console.log('Builder hidding mainpages backdrop 6');
            processAndHideBackdrop();
            document.getElementById("myRightDrawer").style.width = "0";
            rightDrawerOpen = false;
        }

        function closeSideBar() {
            var editbtn = document.querySelector(".editbtn");
            var navbar = document.querySelector(".navbar");
            var horizontalsd = document.querySelector(".horizontalsd");
            var brand = document.querySelector(".brand");
            var recentResume = document.getElementById("recent-resume");
            var editbtn = document.querySelector(".editbtn");
            var dropdown = document.getElementById("dropdown-menu");
            var signupButton = document.getElementById("signup-right");
            var loginButton = document.getElementById("login-right");
            var homebarLogo = document.getElementById("homebar-logo");
            var customLocale3 = document.getElementById("custom-locale3");
            var pricingbtnDiv = document.getElementById("pricingbtnDiv");


            var footersd = document.getElementById("footersd");
            if (signupButton) signupButton.disabled = false;
            if (loginButton) loginButton.disabled = false;
            console.log('MainPage Event hidding modal backdrop 4');
            processAndHideBackdrop();
            document.getElementById("mySidebar").style.width = "0";
            editbtn.style.left = "50px";
            brand.style.left = "55px";
            navbar.classList.remove("homebar");
            if (horizontalsd) horizontalsd.classList.remove("content-container-970");
            if (homebarLogo) homebarLogo.style.marginLeft = "0";
            if (footersd) footersd.style.maxWidth = "100%";
            if (window.innerWidth > WIDTH_BREAKPOINT) {
                if (customLocale3) customLocale3.style.display = 'inline';
                if (pricingbtnDiv) pricingbtnDiv.style.display = 'inline';
            }
            recentResume.style.left = (parseInt(brand.style.left, 10) + 50) + 'px';
            dropdown.style.left = (parseInt(brand.style.left, 10) + (brand.offsetWidth > 200 ? 100 : brand.offsetWidth) / 2) + 'px';
            brand.style.visibility = 'visible';
            sidebarOpenMobile = false;
        }

        function toggleDropdown() {
            var dropdown = document.getElementById("dropdown-menu");
            if (dropdown) {
                if (dropdown.style.display === "none" || dropdown.style.display === "") {
                    const currentPath = window.location.pathname;
                    dropdown.style.display = "block";
                    const dropdownOptions = document.querySelectorAll(".dropdown-menu .custom-option3[data-path]");
                    const matchingDropdown = Array.from(dropdownOptions).find(
                        (opt) => opt.getAttribute("data-path") === currentPath
                    );

                    if (matchingDropdown) {
                        matchingDropdown.classList.add("dropdown-active");
                        return;
                    }
                } else {
                    dropdown.style.display = "none";
                }
            }
        }

        function toggleNav() {
            var sidebar = document.getElementById("mySidebar");
            var editbtn = document.querySelector(".editbtn");
            var brand = document.querySelector(".brand");
            var recentResume = document.getElementById("recent-resume");
            var dropdown = document.getElementById("dropdown-menu");
            var contentWrapper = document.getElementById("content-container-wrapper");
            var signupButton = document.getElementById("signup-right");
            var loginButton = document.getElementById("login-right");
            var navbar = document.querySelector(".navbar");
            var horizontalsd = document.querySelector(".horizontalsd");
            var homebarLogo = document.getElementById("homebar-logo");
            var footersd = document.getElementById("footersd");
            var customLocale3 = document.getElementById("custom-locale3");
            var pricingbtnDiv = document.getElementById("pricingbtnDiv");






            if (sidebar && document.querySelector(".openbtn")) {
                if (window.innerWidth > WIDTH_BREAKPOINT) {
                    sidebarOpenDesktop = !sidebarOpenDesktop; // Toggle the status
                    setSidebarStatus(sidebarOpenDesktop); // Update session storage only here

                    if (sidebarOpenDesktop) {
                        sidebar.style.width = getComputedStyle(document.documentElement).getPropertyValue('--desktop-sidebar-width');
                        navbar.classList.remove("homebar");
                        if (horizontalsd) horizontalsd.classList.add("content-container-970");
                        editbtn.style.left = "235px";
                        brand.style.left = "250px";
                        recentResume.style.left = (parseInt(brand.style.left, 10) + 50) + 'px';
                        if (homebarLogo) homebarLogo.style.marginLeft = getComputedStyle(document.documentElement).getPropertyValue('--desktop-sidebar-width');
                        if (footersd) footersd.style.maxWidth = "1300px";
                        if (customLocale3) customLocale3.style.display = 'none';
                        if (pricingbtnDiv) pricingbtnDiv.style.display = 'none';
                        dropdown.style.left = "300px";
                        contentWrapper.style.width = `calc(100% - ${getComputedStyle(document.documentElement).getPropertyValue('--desktop-sidebar-width')})`;
                        contentWrapper.style.marginLeft = getComputedStyle(document.documentElement).getPropertyValue('--desktop-sidebar-width');
                        document.querySelector(".openbtn").setAttribute("data-original-title", getI18n('home.closeSidebar'));
                    } else {
                        sidebar.style.width = "0";
                        editbtn.style.left = "50px";
                        navbar.classList.add("homebar");
                        if (horizontalsd) horizontalsd.classList.remove("content-container-970");
                        brand.style.left = "55px";
                        recentResume.style.left = (parseInt(brand.style.left, 10) + 50) + 'px';
                        if (homebarLogo) homebarLogo.style.marginLeft = "0";
                        if (footersd) footersd.style.maxWidth = "100%";
                        if (customLocale3) customLocale3.style.display = 'inline';
                        if (pricingbtnDiv) pricingbtnDiv.style.display = 'inline';
                        dropdown.style.left = (parseInt(brand.style.left, 10) + (brand.offsetWidth > 200 ? 100 : brand.offsetWidth) / 2) + 'px';
                        contentWrapper.style.width = "100%";
                        contentWrapper.style.marginLeft = "0";
                        document.querySelector(".openbtn").setAttribute("data-original-title", getI18n('home.openSidebar'));
                    }
                } else {
                    // If the window width is less than CLOSE_SIDEBAR_THRESHOLD, set sidebarOpenDesktop to false
                    sidebarOpenDesktop = false;
                    setSidebarStatus(false); // Update session storage to reflect the closed state

                    sidebarOpenMobile = !sidebarOpenMobile;
                    if (sidebarOpenMobile) {
                        const mobileSidebarWidth = getComputedStyle(document.documentElement).getPropertyValue('--mobile-sidebar-width');
                        const mobileSidebarWidthValue = parseFloat(mobileSidebarWidth);
                        sidebar.style.width = mobileSidebarWidth;
                        editbtn.style.left = (mobileSidebarWidthValue - 60) + 'px';
                        brand.style.visibility = 'hidden';
                        recentResume.style.visibility = 'hidden';
                        if (signupButton) signupButton.disabled = true;
                        if (loginButton) loginButton.disabled = true;
                        if (customLocale3) customLocale3.style.display = 'none';
                        if (pricingbtnDiv) pricingbtnDiv.style.display = 'none';
                        showModalBackDrop();


                        document.querySelector(".openbtn").setAttribute("data-original-title", getI18n('home.closeSidebar'));
                    } else {
                        sidebar.style.width = "0";
                        editbtn.style.left = "50px";
                        brand.style.left = "55px";
                        recentResume.style.left = (parseInt(brand.style.left, 10) + 50) + 'px';
                        dropdown.style.left = (parseInt(brand.style.left, 10) + (brand.offsetWidth > 200 ? 100 : brand.offsetWidth) / 2) + 'px';
                        brand.style.visibility = 'visible';
                        recentResume.style.visibility = 'visible';
                        if (signupButton) signupButton.disabled = false;
                        if (loginButton) loginButton.disabled = false;
                        if (customLocale3) customLocale3.style.display = 'none';
                        if (pricingbtnDiv) pricingbtnDiv.style.display = 'none';
                        console.log('MainPage Event hidding modal backdrop 5');
                        processAndHideBackdrop();
                        document.querySelector(".openbtn").setAttribute("data-original-title", getI18n('home.openSidebar'));
                    }
                }
            }
            $('[data-toggle="tooltip"]').tooltip('hide'); // Hide tooltip after clicking
        }

        function adjustText() {
            $('.example-text').each(function () {
                var $this = $(this);

                // Store the original text
                var fullText = $this.data('original-text') || $this.text(); // Use data attribute to store original text

                // Create the ellipsis span and SVG element
                var ellipsisSpan = $('<span class="ellipsis-tooltip">...</span>').css('font-size', '14px').css('cursor', 'pointer');
                var svgIcon = $('<span class="svg-tooltip"></span>').html(`
                <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 -960 960 960" fill="#5f6368" style="cursor: pointer;">
                    <path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
                </svg>
            `);

                // Temporarily append ellipsis and SVG to measure their combined width
                $this.text(fullText).append(ellipsisSpan).append(svgIcon);
                var extraWidth = ellipsisSpan.outerWidth() + svgIcon.outerWidth();
                var availableWidth = $this.innerWidth();

                // Measure the full width of the text without truncation
                var fullTextWidth = $this[0].scrollWidth;

                // Reset text to original after measuring
                $this.text(fullText);

                // Store the original text if not already stored
                if (!$this.data('original-text')) {
                    $this.data('original-text', fullText);
                }

                // Check if truncation is needed
                if (fullTextWidth > availableWidth) {
                    // Calculate the number of characters that can fit into the available width minus the space needed for ellipsis and icon
                    var charWidth = fullTextWidth / fullText.length;
                    var visibleChars = Math.floor((availableWidth - extraWidth) / charWidth);

                    // Ensure a minimum number of characters are shown (e.g., at least 5 characters)
                    var minimumVisibleChars = 5;
                    if (visibleChars > minimumVisibleChars && visibleChars < fullText.length) {
                        var truncatedText = fullText.slice(0, visibleChars);
                        // Append the ellipsis and SVG since truncation is occurring
                        $this.text(truncatedText).append(ellipsisSpan).append(svgIcon);
                    } else if (visibleChars <= minimumVisibleChars) {
                        var truncatedText = fullText.slice(0, minimumVisibleChars);
                        // Ensure a minimum of characters are always visible
                        $this.text(truncatedText).append(ellipsisSpan).append(svgIcon);
                    }

                    // Set up the click event to show the SweetAlert2 modal with the full text
                    $this.find('.ellipsis-tooltip, .svg-tooltip').on('click', function () {
                        // Check the immediate parent ID
                        const parentId = $(this).parent().attr('id');
                        const showDenyButton = (parentId === 'example-text-1' || parentId === 'example-text-2');

                        Swal.fire({
                            title: getI18n('swal.fullTextTitle'), // 'Full Text' is replaced with a localized property
                            html: `<textarea class="form-control" style="width: 100%; height: 400px; font-size: 14px; font-family: Arial, sans-serif; color: #212529;" readonly>${fullText}</textarea>`,
                            showCloseButton: true,
                            showCancelButton: true,
                            focusConfirm: false,
                            confirmButtonText: getI18n('swal.copyTextButton'), // 'Copy Text' is replaced with a localized property
                            cancelButtonText: getI18n('swal.closeButton'), // 'Close' is replaced with a localized property
                            showDenyButton: showDenyButton, // Only show if the parent ID is 'example-text-1' or 'example-text-2'
                            denyButtonText: getI18n('swal.insertTextButton'), // 'Insert Text' is replaced with a localized property
                            customClass: {
                                popup: 'swal2-centered', // Center the popup
                                confirmButton: 'btn btn-primary', // Use Bootstrap's .btn-primary
                                cancelButton: 'btn btn-secondary',  // Use Bootstrap's .btn-secondary
                            },
                            preConfirm: () => {
                                const textarea = Swal.getPopup().querySelector('textarea');
                                textarea.select();
                                document.execCommand('copy');
                                Swal.fire({
                                    icon: 'success',
                                    title: getI18n('swal.copiedTitle'), // 'Copied!' is replaced with a localized property
                                    text: getI18n('swal.copiedText'), // 'Text has been copied to clipboard.' is replaced with a localized property
                                    timer: 1500,
                                    showConfirmButton: false
                                });
                            }
                        }).then((result) => {
                            if (result.isDenied) {
                                // Insert the text into the textbox with id="chatgptbox"
                                const textarea = Swal.getPopup().querySelector('textarea');
                                const chatgptbox = document.getElementById('chatgptbox');
                                if (chatgptbox) {
                                    chatgptbox.value = textarea.value;
                                    chatgptbox.focus(); // Optionally focus the textbox
                                }
                            }
                        });
                    });

                } else {
                    // No truncation needed, display the original text without the ellipsis and SVG
                    $this.text(fullText);
                }
            });
        }

        function unloadInit() {
            window.removeEventListener('resize', adjustContentContainer);
            if (leftsidebarpopulate.unload) {
                leftsidebarpopulate.unload();
            }
        }


        function adjustContentContainer() {
            var sidebar = document.getElementById("mySidebar");
            var contentWrapper = document.getElementById("content-container-wrapper");
            var editbtn = document.querySelector(".editbtn");
            var brand = document.querySelector(".brand");
            var recentResume = document.getElementById("recent-resume");
            var dropdown = document.getElementById("dropdown-menu");
            var rightDrawer = document.getElementById("myRightDrawer");
            var signupButton = document.getElementById("signup-right");
            var loginButton = document.getElementById("login-right");
            var leftSideContainerTop = document.getElementById("leftSideContainerTop");
            var navbar = document.querySelector(".navbar");
            contentWrapper.style.left = "0";
            contentWrapper.style.width = `calc(100% - ${getComputedStyle(document.documentElement).getPropertyValue('--desktop-sidebar-width')})`;
            if (leftSideContainerTop) leftSideContainerTop.style.visibility = "visible";




            if (sidebar && document.querySelector(".openbtn")) {
                if (window.innerWidth > WIDTH_BREAKPOINT) {
                    if (window.innerWidth < CLOSE_SIDEBAR_THRESHOLD) {
                        // Hide the sidebar for widths less than CLOSE_SIDEBAR_THRESHOLD (1220)
                        sidebar.style.width = "0";
                        contentWrapper.style.width = "100%";
                        contentWrapper.style.marginLeft = "0";
                        editbtn.style.left = "50px";
                        brand.style.left = "55px";
                        recentResume.style.left = (parseInt(brand.style.left, 10) + 50) + 'px';
                        dropdown.style.left = (parseInt(brand.style.left, 10) + (brand.offsetWidth > 200 ? 100 : brand.offsetWidth) / 2) + 'px';
                    } else if (sidebarOpenDesktop) {
                        // Open the sidebar if it's open and the width is greater than CLOSE_SIDEBAR_THRESHOLD
                        sidebar.style.width = getComputedStyle(document.documentElement).getPropertyValue('--desktop-sidebar-width');
                        contentWrapper.style.width = `calc(100% - ${getComputedStyle(document.documentElement).getPropertyValue('--desktop-sidebar-width')})`;
                        contentWrapper.style.marginLeft = getComputedStyle(document.documentElement).getPropertyValue('--desktop-sidebar-width');
                        if (signupButton) signupButton.disabled = false;
                        if (loginButton) loginButton.disabled = false;
                        if (
                            ($('#resumeSidebar').length && $('#resumeSidebar').hasClass('open')) || // Check if resumeSidebar exists and is open
                            ($('#fileUploadModal').length && $('#fileUploadModal').hasClass('fileUpload-show')) ||
                            ($('#page-setup-myModal').length && $('#page-setup-myModal').css('display') !== 'none' && $('#page-setup-myModal').css('display') !== '') // Check if pageSetupModal is visible
                        ) {//don't hide sidebar
                        } else {
                            processAndHideBackdrop();
                        }
                        editbtn.style.left = "235px";
                        brand.style.left = "250px";
                        recentResume.style.left = (parseInt(brand.style.left, 10) + 50) + 'px';
                        dropdown.style.left = (parseInt(brand.style.left, 10) + (brand.offsetWidth > 200 ? 100 : brand.offsetWidth) / 2) + 'px';
                    } else {
                        // Keep the sidebar closed if the window is resized beyond the CLOSE_SIDEBAR_THRESHOLD
                        sidebar.style.width = "0";
                        contentWrapper.style.width = "100%";
                        contentWrapper.style.marginLeft = "0";
                        if (signupButton) signupButton.disabled = false;
                        if (loginButton) loginButton.disabled = false;
                        console.log('MainPage Event hidding modal backdrop 6');
                        processAndHideBackdrop();
                        editbtn.style.left = "50px";
                        brand.style.left = "55px";
                        recentResume.style.left = (parseInt(brand.style.left, 10) + 50) + 'px';
                        dropdown.style.left = (parseInt(brand.style.left, 10) + (brand.offsetWidth > 200 ? 100 : brand.offsetWidth) / 2) + 'px';
                    }

                    if (rightDrawerOpen) {
                        rightDrawer.style.width = getComputedStyle(document.documentElement).getPropertyValue(window.innerWidth > WIDTH_BREAKPOINT ? '--desktop-rightdrawer-width' : '--mobile-rightdrawer-width');
                    } else {
                        rightDrawer.style.width = "0";
                    }

                } else {
                    if (sidebarOpenMobile) {
                        sidebar.style.width = getComputedStyle(document.documentElement).getPropertyValue('--mobile-sidebar-width');
                        if (signupButton) signupButton.disabled = true;
                        if (loginButton) loginButton.disabled = true;
                        showModalBackDrop();
                    } else {
                        sidebar.style.width = "0";
                        if (signupButton) signupButton.disabled = false;
                        if (loginButton) loginButton.disabled = false;
                        // console.log ('MainPage Event hidding modal backdrop 7');
                        processAndHideBackdrop();
                    }
                    contentWrapper.style.width = "100%";
                    contentWrapper.style.marginLeft = "0";
                    editbtn.style.left = "50px";
                    brand.style.left = "55px";
                    recentResume.style.left = (parseInt(brand.style.left, 10) + 50) + 'px';
                    dropdown.style.left = (parseInt(brand.style.left, 10) + (brand.offsetWidth > 200 ? 100 : brand.offsetWidth) / 2) + 'px';
                }
            }

            // Adjust text on page load
            //adjustText();

            let isDarkMode = $('html').hasClass('dark-theme');
            let tooltiptext = isDarkMode ? getI18n('home.setLightkMode') : getI18n('home.setDarkMode');
            $("#settingsbtn").attr("data-original-title", tooltiptext).tooltip('dispose').tooltip();

            if (!isTouchScreen()) {
                // Initialize tooltips with hover trigger if not on a touch screen
                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            } else {
                // Dispose of tooltips on mobile or touch screen devices
                $('[data-toggle="tooltip"]').tooltip('dispose');
            }

            if (sidebarOpenDesktop) {
                document.querySelector(".openbtn").setAttribute("data-original-title", getI18n('home.closeSidebar'));
            }
        }

        window.addEventListener('resize', function () {
            if (document.querySelector(".openbtn")) {
                adjustContentContainer();
                if (!isTouchScreen()) {
                    // Initialize tooltips with hover trigger if not on a touch screen
                    $('[data-toggle="tooltip"]').tooltip({
                        trigger: 'hover'
                    });
                } else {
                    // Dispose of tooltips on mobile or touch screen devices
                    $('[data-toggle="tooltip"]').tooltip('dispose');
                }
            }
        });

        // Initialize sidebar state on page load
        initializeSidebar();



        setCustomTimeout(() => {
            if (isTouchScreen()) {
                $('[data-toggle="tooltip"]').tooltip('dispose'); // Hide tooltip after clicking on mobile
            } else {
                $('[data-toggle="tooltip"]').tooltip('hide'); // Hide tooltip after clicking on desktop
            }
        }, 200);

        this.updateLeftSidebarButtons();



        const leftSidebarScrollableDiv = document.getElementById('leftSidebarScrollableDiv');
        const leftSidebarScrollUpButton = document.getElementById('leftSidebarScrollUp');
        const leftSidebarScrollDownButton = document.getElementById('leftSidebarScrollDown');


        // Scroll down on button click
        leftSidebarScrollDownButton.addEventListener('click', () => {
            if (!leftSidebarScrollDownButton.disabled) {
                leftSidebarScrollableDiv.scrollBy({
                    top: 100, // Adjust the value to scroll more or less
                    behavior: 'smooth'
                });
            }
        });

        // Scroll up on button click
        leftSidebarScrollUpButton.addEventListener('click', () => {
            if (!leftSidebarScrollUpButton.disabled) {
                leftSidebarScrollableDiv.scrollBy({
                    top: -100, // Adjust the value to scroll more or less
                    behavior: 'smooth'
                });
            }
        });

        // Listen to scroll events and update buttons
        leftSidebarScrollableDiv.addEventListener('scroll', this.updateLeftSidebarButtons);

        // Initial button state on page load
        this.updateLeftSidebarButtons();
        window.addEventListener('resize', this.updateLeftSidebarButtons); // Re-check on window resize

        document.body.style.visibility = "visible";

        var editbtn = document.querySelector(".editbtn");
        var brand = document.querySelector(".brand");
        var dropdown = document.getElementById("dropdown-menu");
        var recentResume = document.getElementById("recent-resume");

        editbtn.style.visibility = "visible";
        brand.style.visibility = "visible";
        recentResume.style.visibility = "visible";
        dropdown.style.visibility = "visible";


    },
    updateLeftSidebarButtons() {
        const leftSidebarScrollableDiv = document.getElementById('leftSidebarScrollableDiv');
        const leftSidebarScrollUpButton = document.getElementById('leftSidebarScrollUp');
        const leftSidebarScrollDownButton = document.getElementById('leftSidebarScrollDown');
        const arrowContainer = document.getElementById('arrowContainer');
        // If the content does not overflow, remove arrows and make the scrollable div full height
        if (leftSidebarScrollableDiv.scrollHeight <= leftSidebarScrollableDiv.clientHeight) {
            arrowContainer.style.display = 'none';
            leftSidebarScrollableDiv.style.height = '100%';
        } else {
            // Restore arrows when content overflows and allow scroll behavior
            arrowContainer.style.display = 'flex';

            // Enable/disable arrows based on scroll position

            // At the top, disable the up arrow and add disabled class
            if (leftSidebarScrollableDiv.scrollTop === 0) {
                leftSidebarScrollUpButton.disabled = true;
                leftSidebarScrollUpButton.querySelector('svg').classList.add('arrow-disabled');
                leftSidebarScrollUpButton.querySelector('svg').classList.remove('arrow-hover');
            } else {
                leftSidebarScrollUpButton.disabled = false;
                leftSidebarScrollUpButton.querySelector('svg').classList.remove('arrow-disabled');
                leftSidebarScrollUpButton.querySelector('svg').classList.add('arrow-hover');
            }

            // At the bottom, disable the down arrow and add disabled class
            if (leftSidebarScrollableDiv.scrollTop + leftSidebarScrollableDiv.clientHeight >= leftSidebarScrollableDiv.scrollHeight) {
                leftSidebarScrollDownButton.disabled = true;
                leftSidebarScrollDownButton.querySelector('svg').classList.add('arrow-disabled');
                leftSidebarScrollDownButton.querySelector('svg').classList.remove('arrow-hover');
            } else {
                leftSidebarScrollDownButton.disabled = false;
                leftSidebarScrollDownButton.querySelector('svg').classList.remove('arrow-disabled');
                leftSidebarScrollDownButton.querySelector('svg').classList.add('arrow-hover');
            }
        }
    },
    unload() {
        // Function to remove styles (inline and class attributes) recursively
        const removeAllStylesRecursively = (element) => {
            $(element)
                .find("*") // Target all descendants
                .each(function () {
                    $(this).removeAttr("style").removeAttr("class");
                });
            $(element).removeAttr("style").removeAttr("class"); // Clean styles for the element itself
        };

        // Remove click event listeners
        $(document).off('click', '#brand');
        $(document).off('click', '#openbtn');
        $(document).off('click', '#loggedin-right-main:has(*)');
        $(document).off('click', '#rightdrawercloseButton');
        $(document).off('click', '#closeSidebar');
        $('#rightdrawer-main-logout').off('click');
        $('#copyTextBtn').off('click');
        $(document).off('click', '#settingslink, #settingsbtn');

        // Clear dynamically added elements and tooltips
        $('[data-toggle="tooltip"]').tooltip('dispose'); // Remove tooltips
        $('.modal-backdrop').remove(); // Remove modal backdrop if exists

        // Remove button click listeners
        const leftSidebarScrollUpButton = document.getElementById('leftSidebarScrollUp');
        const leftSidebarScrollDownButton = document.getElementById('leftSidebarScrollDown');

        if (leftSidebarScrollUpButton) {
            leftSidebarScrollUpButton.removeEventListener('click', this.scrollUpHandler);
            removeAllStylesRecursively(leftSidebarScrollUpButton);
        }
        if (leftSidebarScrollDownButton) {
            leftSidebarScrollDownButton.removeEventListener('click', this.scrollDownHandler);
            removeAllStylesRecursively(leftSidebarScrollDownButton);
        }

        if (leftsidebarpopulate.unload) {
            leftsidebarpopulate.unload();
        }

        // Remove and clean up other elements
        const editbtn = document.querySelector(".editbtn");
        if (editbtn) {
            removeAllStylesRecursively(editbtn);
            editbtn.remove();
        }

        const dropdown = document.getElementById("dropdown-menu");
        if (dropdown) {
            removeAllStylesRecursively(dropdown);
            dropdown.remove();
        }

        const signupButton = document.getElementById("signup-right");
        if (signupButton) {
            removeAllStylesRecursively(signupButton);
            signupButton.remove();
        }

        const loginButton = document.getElementById("login-right");
        if (loginButton) {
            removeAllStylesRecursively(loginButton);
            loginButton.remove();
        }

        // Remove scroll-related event listeners and clean children
        const leftSidebarScrollableDiv = document.getElementById('leftSidebarScrollableDiv');
        if (leftSidebarScrollableDiv) {
            leftSidebarScrollableDiv.removeEventListener('scroll', mainPageEvents.updateLeftSidebarButtons);
            removeAllChildrenAndStyles(leftSidebarScrollableDiv);
        }

        // Remove all children and clean styles for $sidebar and $rightDrawer

        const lsidebar = document.getElementById('mySidebar');
        const rrightDrawer = document.getElementById('myRightDrawer');
        const navbar = document.getElementById('navbar');

        if (lsidebar) {
            removeAllChildrenAndStyles(lsidebar);
        }

        if (rrightDrawer) {
            removeAllChildrenAndStyles(rrightDrawer);
        }

        if (navbar) {
            removeAllChildrenAndStyles(navbar);
        }
    },
    scrollUpHandler() {
        const leftSidebarScrollableDiv = document.getElementById('leftSidebarScrollableDiv');
        if (leftSidebarScrollableDiv && !this.disabled) {
            leftSidebarScrollableDiv.scrollBy({ top: -100, behavior: 'smooth' });
        }
    },

    scrollDownHandler() {
        const leftSidebarScrollableDiv = document.getElementById('leftSidebarScrollableDiv');
        if (leftSidebarScrollableDiv && !this.disabled) {
            leftSidebarScrollableDiv.scrollBy({ top: 100, behavior: 'smooth' });
        }
    }


};


export default mainPageEvents;